






























































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditSmokeleaf from "./edit-somkeleaf.vue";
import CreateSmokeleaf from "./create-somkeleaf.vue";
class PageSmokeleafRequest extends PageRequest {
  //FilterText: string;
  ftId:Number;
  wId:Number;
  fId:Number;
  keyword:string;
}
class PageCompanyRequest{
  cId:Number;
  ftId:Number;
  wId:Number;
  fId:Number;
}
@Component({
  components: { EditSmokeleaf, CreateSmokeleaf },
})
export default class Smokeleafs extends AbpBase {
  pagerequest: PageSmokeleafRequest = new PageSmokeleafRequest();
  publicpagerequest: PageSmokeleafRequest = new PageSmokeleafRequest();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  userName: string;
  cId:Number;
  selwarehouselist = [];
  selfloorlist = [];

  get list() {
    return this.$store.state.smokeleaf.list;
  }
  get loading() {
    return this.$store.state.smokeleaf.loading;
  }
  pageChange(page: number) {
    this.$store.commit("smokeleaf/setCurrentPage", page);
    this.getPage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("smokeleaf/setPageSize", pagesize);
    this.getPage();
  }
  getsearch(){
    this.$store.state.thequipment.currentPage=1;
    this.getPage();
  }
  async getPage() {
     this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    await this.$store.dispatch({
      type: "smokeleaf/getPaged",
      data: this.pagerequest,
    });
  }

  async getAll() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    await this.$store.dispatch({
      type: "smokeleaf/getAll",
      data: this.pagerequest,
    });
  }

  edit() {
    this.editModalShow = true;
  }
  create() {
    this.createModalShow = true;
  }
  get pageSize() {
    return this.$store.state.smokeleaf.pageSize;
  }
  get totalCount() {
    return this.$store.state.smokeleaf.totalCount;
  }
  get currentPage() {
    return this.$store.state.smokeleaf.currentPage;
  }
  getuserName() {
    //console.log(this.$store.state.session.user);
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
    companylist() {
    return this.$store.state.company.list;
  }
  get company(){
    return this.$store.state.company.list;
  }
  get floor() {
    return this.$store.state.floor.list;
  }
  floorlist() {
    return this.$store.state.floor.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.list;
  }
  warehouselist() {
    return this.$store.state.warehouse.list;
  }
    get smokecrib() {
    return this.$store.state.smokecrib.list;
  }
  smokecriblist(){
    return this.$store.state.smokecrib.list;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  factorylist(){
    return this.$store.state.factory.list;
  }

  selCompany(value:Number){
    this.pagecompanyrequest.cId = value;
    this.getfactory();
    this.getwarehouse();
      this.getfloor();
       this.getAll();
  }

  columns = [
     {
      title: "所属公司",
      key: "cId",
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(cId==entry.id){
            cId=entry.cName;
            break;
          }
        }
        if(cId==0){
          cId="";
        }
        return h("span", cId);
      },
    },
    {
      title: "库区",
      key: "ftId",
      render: (h, params) => {
        let Id = params.row.ftId;
        let flist = this.factorylist();
        //console.log(clist); 
        for (let entry of flist) {
          if(Id==entry.id){
            Id=entry.fName;
            break;
          }
        }
        return h("span", Id);
      },
    },
    {
      title: "库房",
      key: "wId",
       render: (h, params) => {
        let wId = params.row.wId;
        let clist = this.warehouselist();
        //console.log(clist); 
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(wId==entry.id){
            wId=entry.wName;
            break;
          }
        }
        return h("span", wId);
      },
    },
    {
      title: "楼层",
      key: "fId",
      render: (h, params) => {
        let fId = params.row.fId;
        let clist = this.floorlist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(fId==entry.id){
            fId=entry.fName;
            break;
          }
        }
        return h("span", fId);
      },
    },
    {
      title: "垛位号",
      key: "sId",
       render: (h, params) => {
        let scId = params.row.sId;
        let clist = this.smokecriblist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(scId==entry.id){
               scId=entry.locationName;
            break;
          }
        }
        return h("span", scId);
      },
    },
    {
      title: "烟草产地",
      key: "yieldly",
    },
    {
      title: "烟叶年份",
      key: "year",
    },
    {
      title: "烟叶等级",
      key: "grade",
    },
     {
      title: "烟叶数量",
      key: "allamount",
    },
    {
      title: "每箱质量",
      key: "weight",
       render: (h, params) => {
        return h("span", params.row.weight+'/kg');
      },
    },
    {
      title: "剩余数量",
      key: "samount",
    },
    {
      title: "入库时间",
      key: "comeTime",
      render: (h, params) => {
        let ComeTime ='';
        
        ComeTime=this.GetDay(params.row.comeTime)+ " " +this.GetMinutes(params.row.comeTime);
        return h("span", ComeTime);
      },
    },
    {
      title: "出库时间",
      key: "outTime",
      render: (h, params) => {
        let OutTime ='';
        
        OutTime=this.GetDay(params.row.outTime)+ " " +this.GetMinutes(params.row.outTime);
        return h("span", OutTime);
      },
    },
    {
      title: "操作",
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  //console.log(params.row);
                  this.$store.commit("smokeleaf/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",  
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: "提示",
                    content: "确认删除该条数据？",
                    okText: "删除",
                    cancelText: "取消",
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "smokeleaf/delete",
                        data: params.row,
                      });
                      await this.getPage();
                    },
                  });
                },
              },
            },
            "删除"
          ),
        ]);
      },
    },
  ];
   async getcompany() {
    this.publicpagerequest.maxResultCount = 99;
    this.publicpagerequest.skipCount = 0;
    //filters
    await this.$store.dispatch({
      type: "company/getAll",
      data: this.publicpagerequest,
    });
  }
  async getfactory(){
      //库区
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      data: this.pagecompanyrequest,
    });
  }
  GetDay(time) {
    let date = new Date(time);
    let Str = date.getFullYear() + "-" + (date.getMonth()+1) + "-" + date.getDate();
    return Str;
  }

  GetMinutes(time) {
    let date = new Date(time);
    let Str = this.GetBqMinutes(date.getHours()) + ":" + this.GetBqMinutes(date.getMinutes());
    return Str;
  }
GetBqMinutes(str){
    if(str.toString().length==1){
      return '0'+str;
    }
    return str;
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getAll",
      data: this.pagecompanyrequest,
    });
  }
   async getselwarehouse(){
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
  async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
  selfactory(value:Number){
    this.pagecompanyrequest.ftId = value;
    this.pagerequest.ftId = value;
    if(value != 0){
      this.getselwarehouse();
    }
    else
    {
      this.selwarehouselist = [];
      this.selfloorlist = [];
    }
       this.$store.state.thequipment.currentPage=1;
       this.getPage();
  }
  selwarehouse(value:Number){
    this.pagecompanyrequest.wId = value;
    this.pagerequest.wId = value;
    if(value != 0 && value != undefined){
      this.getselfloor();
    }
    else{
      this.selfloorlist = [];
    }
       this.$store.state.thequipment.currentPage=1;
       this.getPage();
  }
  selfloor(value:Number){
       this.$store.state.thequipment.currentPage=1;
       this.pagerequest.fId = value;
       this.getPage();
  }
  async getsmokecrib(){
   //烟叶
    //filters
    await this.$store.dispatch({
      type: "smokecrib/getAll",
       data: this.pagecompanyrequest,
    });
 }
   async getthreshold(){
      //阈值方案
    //filters
    await this.$store.dispatch({
      type: "threshold/getAll",
      data: this.publicpagerequest,
    });
  }

  created() {
    this.getuserName();
    if (this.userName !== "admin") {
      this.getfactory();
      this.getwarehouse();
      this.getfloor();
      this.getsmokecrib();
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    }else{
      this.getcompany();
    }
    this.getPage();
  }
}
